require('./bootstrap');

import { createApp } from 'vue';
import i18n from './i18n.js';
import Home from './components/pages/Home.vue';
import Login from './components/pages/Login.vue';
import Settings from './components/pages/Settings.vue';
import OrderCreate from './components/pages/OrderCreate.vue';
import OrderList from './components/pages/OrderList.vue';
import OrderSingle from './components/pages/OrderSingle.vue';
import Sidebar from './components/layout/Sidebar.vue';
import Navigation from './components/layout/Navigation.vue';
import Footer from './components/layout/Footer.vue';
import PasswordResetReminder from './components/layout/PasswordResetReminder.vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowDown19,
  faArrowDown91,
  faArrowRight,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faFile,
  faFileAudio,
  faFileCsv,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord,
  faFileZipper,
  faFloppyDisk,
  faGear,
  faHouse,
  faLink,
  faList,
  faMagnifyingGlass,
  faPaperPlane,
  faPlus,
  faRotate,
  faUser,
  faUserSlash,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faArrowDown19,
  faArrowDown91,
  faArrowRight,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faFile,
  faFileAudio,
  faFileCsv,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord,
  faFileZipper,
  faFloppyDisk,
  faGear,
  faHouse,
  faLink,
  faList,
  faMagnifyingGlass,
  faPaperPlane,
  faPlus,
  faRotate,
  faUser,
  faUserSlash,
  faXmark,
);

const app = createApp({
  data() {
    return {
      sidebarExpanded: localStorage.getItem('sidebarExpanded') === 'false' ? false : true
    }
  },
  methods: {
    sidebarChange() {
      const value = !this.sidebarExpanded;
      this.sidebarExpanded = value;
      localStorage.setItem('sidebarExpanded', value);
    },
    logout: async function () {
      await fetch('/api/user/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      localStorage.clear();
      window.location.href = '/login';
    }
  }
});
app.use(i18n);
app.component('home', Home)
  .component('login', Login)
  .component('settings', Settings)
  .component('order-create', OrderCreate)
  .component('order-list', OrderList)
  .component('order-single', OrderSingle)
  .component('sidebar', Sidebar)
  .component('navigation', Navigation)
  .component('v-footer', Footer)
  .component('password-reset-reminder', PasswordResetReminder)
  .component('font-awesome-icon', FontAwesomeIcon);
app.mount("#app");
